export const UPDATE_BATCH_ROWS = 'UPDATE_BATCH_ROWS';
export const UPDATE_SELECTED_BATCH = 'UPDATE_SELECTED_BATCH';
export const UPDATE_STUDENT_ROWS = 'UPDATE_STUDENT_ROWS';
export const UPDATE_SELECTED_STUDENT = 'UPDATE_SELECTED_STUDENT';
export const GET_CALCULATE = 'GET_CALCULATE'
export const GET_NONSTUDENT = 'GET_NONSTUDENT'
export const UPDATE_NON_STUDENT = 'UPDATE_NON_STUDENT'
export const GET_SUMMARY_CALCULATE = 'GET_SUMMARY_CALCULATE'
export const UPDATE_NON_STUDENT_TAB = 'UPDATE_NON_STUDENT_TAB'
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS'
export const UPDATE_EXCHANGE_RATES = 'UPDATE_EXCHANGE_RATES'
export const RESET_STATE = 'RESET_STATE'
export const GET_PARKING_BATCHES = 'GET_PARKING_BATCHES'
export const GET_PARKING_BATCH_DETAIL = 'GET_PARKING_BATCH_DETAIL'
export const POST_PARKING_BATCH = 'POST_PARKING_BATCH'
export const INITIATE_MANUAL_PARKING_REFUND = 'INITIATE_MANUAL_PARKING_REFUND'
export const SET_BATCH_TYPE_FILTER = 'SET_BATCH_TYPE_FILTER'
export const FETCH_PARKING_BATCHES = 'FETCH_PARKING_BATCHES';
export const FETCH_PARKING_BATCHES_SUCCESS = 'FETCH_PARKING_BATCHES_SUCCESS';
export const FETCH_PARKING_BATCHES_ERROR = 'FETCH_PARKING_BATCHES_ERROR';
export const FETCH_PARKING_BATCH_LINE_ITEMS = 'FETCH_PARKING_BATCH_LINE_ITEMS';
export const FETCH_PARKING_BATCH_LINE_ITEMS_SUCCESS = 'FETCH_PARKING_BATCH_LINE_ITEMS_SUCCESS';
export const FETCH_PARKING_BATCH_LINE_ITEMS_ERROR = 'FETCH_PARKING_BATCH_LINE_ITEMS_ERROR';
export const POST_PARKING_BATCH_SUCCESS = 'POST_PARKING_BATCH_SUCCESS';
export const POST_PARKING_BATCH_ERROR = 'POST_PARKING_BATCH_ERROR';
export const INITIATE_PARKING_REFUND = 'INITIATE_PARKING_REFUND';
export const INITIATE_PARKING_REFUND_SUCCESS = 'INITIATE_PARKING_REFUND_SUCCESS';
export const INITIATE_PARKING_REFUND_ERROR = 'INITIATE_PARKING_REFUND_ERROR';





